import React from "react";

class OptionObservation extends React.Component {
state = {
        dataset: []
    };
    componentDidMount(props)
   {
    let id = this.props.id;
        fetch(`http://localhost:8090/api/orders/${id}`)
            .then((response) => response.json())
            .then(data => {
                this.setState({ dataset: data });
            });	 
 }
	render(){
  return (
    <div>
	<div className="row">
{this.state.dataset.map((machine,i) => (
<div key={i} className="col-sm-12">
<div className="card">
<div className="card-header">
<h5>Option & Observation</h5>
</div>
<div className="card-body">
<form id="validation-form123">
<div className="row">
<div className="col">
<div className="form-group">
 <label className="form-label">Observation 1</label>
<textarea className="form-control" name="OBSERVATION1" defaultValue={machine.OBSERVATION1}>
</textarea>
{/* <label className="form-label">Observation 2</label>
<input type="text" className="form-control" name="OBSERVATION2" defaultValue={machine.OBSERVATION2} />
<label className="form-label">Observation 3</label>
<input type="text" className="form-control" name="OBSERVATION3" defaultValue={machine.OBSERVATION3} />
<label className="form-label">Observation 4</label>
<input type="text" className="form-control" name="OBSERVATION4" defaultValue={machine.OBSERVATION4} />
<label className="form-label">Option</label>
<input type="text" className="form-control" name="OPTION1" defaultValue={machine.OPTION1} /> */}
</div>
</div>
</div>
<div className="row">
<div className="col">
<div className="form-group">
 <label className="form-label">Standard Operating Procedure</label>
<textarea className="form-control" name="validation-text"></textarea>
</div>
</div>
</div>
<div className="row">
<div className="col">
<div className="form-group">
 <label className="form-label">problem Observed</label>
<textarea className="form-control" name="validation-text"></textarea>
</div>
</div>
</div>
<button type="submit" className="btn  btn-primary mx-1">Save</button>
<button type="submit" className="btn  btn-primary mx-1">close</button>
<button type="submit" className="btn  btn-primary mx-1">Import Details</button>
<button type="submit" className="btn  btn-primary mx-1 my-1">characteristics</button>
</form>
</div>
</div>
</div>
))}
</div>
    </div>
  );
	}
}

export default OptionObservation;